import React, { Component } from 'react';
import { string, shape, func, node, bool } from 'prop-types';
import { sanitizeHrefValue } from 'Shared/components/DraftEditor/utils';

import './SmartLink.scss';
class SmartLink extends Component {
  static propTypes = {
    entityKey: string.isRequired,
    children: node.isRequired,
    contentState: shape({
      getEntity: func.isRequired,
    }).isRequired,
    hasBadge: bool,
  };

  render() {
    const { entityKey, children, contentState } = this.props;
    const { href } = contentState.getEntity(entityKey).getData();
    return (
      <a className="SmartLink" target="_blank" rel="noopener noreferrer" href={sanitizeHrefValue(href)}>
        {children}
      </a>
    );
  }
}

export default SmartLink;
